<template>
  <v-autocomplete
    v-bind="$attrs"
    v-model="itemValue"
    :items="items"
    :search-input.sync="search"
    hide-selected
    cache-items
    ref="autocomplete"
  >
    <template v-slot:no-data>
      <slot name="no-data">
        <div class="px-3 py-2">No Data</div>
      </slot>
    </template>

    <template v-slot:item="{item}">
      <slot name="item" v-bind:item="item">{{item[$attrs['item-text']]}}</slot>
    </template>

    <template v-slot:selection="{item}">
      <slot name="selection" v-bind:item="item">{{item[$attrs['item-text']]}}</slot>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from "lodash";
export default {
  name: "async-autocomplete",
  inheritAttrs: false,
  props: {
    value: null,
    url: String,
    queries: String,
    resetOnBlur: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      search: "",
      searchQueryIsDirty: false,
      isCalculating: false
    };
  },
  computed: {
    itemValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },
  watch: {
    search(val) {
      this.searchQueryIsDirty = true;
      val && val !== this.itemValue && this.searchItem();
    }
  },
  methods: {
    searchItem: _.debounce(function() {
      this.isCalculating = true;

      this.axios
        .get(
          `${this.url}?search=${encodeURIComponent(this.search)}&${
            this.queries
          }`
        )
        .then(({ data }) => {
          this.items = data.data ? data.data : data;
          this.isCalculating = false;
          this.searchQueryIsDirty = false;
        });
    }, 500)
  }
};
</script>

<style scoped>
</style>